export default __webpack_public_path__ + "static/media/ProfilePicture.ca36be52.jpg";